import React, { useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, VStack } from "@chakra-ui/react";
import { ROUTE_BENEFICIARY_FILE_STATUS } from "../navigation/routes";
import { useFake } from "../hooks";
import { useTranslation } from "react-i18next";
import CustomerCard from "../components/services/CustomerCard";
import AvailableServicesCard from "../components/services/AvailableServicesCard";
import OrganisedServicesCard from "../components/services/OrganisedServicesCard";

const BeneficiaryServicesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { beneficiaryId } = useParams();
  const { getAssistanceFromHistory, updateAssistanceFromHistory } = useFake();

  const currentAssistance = useMemo(
    () => getAssistanceFromHistory(beneficiaryId),
    [beneficiaryId, getAssistanceFromHistory],
  );

  const onLaunchIntervention = useCallback(() => {
    navigate(ROUTE_BENEFICIARY_FILE_STATUS(beneficiaryId));
    updateAssistanceFromHistory({
      ...currentAssistance,
      status: "closed",
    });
  }, [currentAssistance, navigate, updateAssistanceFromHistory, beneficiaryId]);

  return (
    <VStack alignItems={"stretch"} flexGrow={1} gap={4} marginX={4}>
      <CustomerCard
        beneficiaryName={`${currentAssistance?.data?.lastName || ""} ${
          currentAssistance?.data?.firstName || ""
        }`}
        licensePlate={currentAssistance?.data?.licensePlate}
        vehicleBrand={currentAssistance?.data?.brand}
        vehicleModel={currentAssistance?.data?.model}
      />
      <AvailableServicesCard />
      <OrganisedServicesCard />
      <Button
        alignSelf={"flex-start"}
        onClick={onLaunchIntervention}
        size={"md"}
        type={"submit"}
        variant={"secondary"}
      >
        {t("beneficiaryServices.launchIntervention")}
      </Button>
    </VStack>
  );
};

export default React.memo(BeneficiaryServicesPage);
